import PropTypes from 'prop-types';
import { useThemeStore } from '@store';

export default function Card({
  children,
  className = '',
  padding = 'md',
  hoverable = false,
  onClick,
}) {
  const { theme } = useThemeStore();
  const isDark = theme === 'dark';

  const paddingStyles = {
    none: {},
    sm: { padding: '12px' },
    md: { padding: '20px' },
    lg: { padding: '24px' },
  };

  const baseStyle = {
    backgroundColor: isDark ? '#1e293b' : 'white',
    borderRadius: '16px',
    boxShadow: isDark ? '0 1px 3px rgba(0,0,0,0.2)' : '0 1px 3px rgba(0,0,0,0.08)',
    border: isDark ? '1px solid #334155' : '1px solid rgba(226, 232, 240, 0.5)',
    color: isDark ? '#e2e8f0' : '#1e293b',
    transition: 'background-color 0.3s ease, border-color 0.3s ease',
    ...paddingStyles[padding],
  };

  const hoverClass = hoverable ? 'card-hover cursor-pointer' : '';

  return (
    <div
      className={`${hoverClass} ${className}`}
      style={baseStyle}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  hoverable: PropTypes.bool,
  onClick: PropTypes.func,
};
